import * as React from "react"
import * as ReactDOM from "react-dom"
import {CallJs} from "../lib/types"
import {connect, Store} from "react-redux"
import {Dispatch, createStore, Reducer} from "redux";

type OptionsCollection = {[key: string]: string}

type Params = {
	name: string
	selected: string
	options: OptionsCollection
}

type State = {
	selected: string
}

type OwnProps = {
	name: string
	options: OptionsCollection
	store: Store<State>
}

type CallbackParams = {
	onChange: (selected: string) => void
}

const Select = (params: Params & CallbackParams) => <select value={params.selected} onChange={(e) => params.onChange(e.currentTarget.value)} name={params.name}>
	<option value="0">All</option>
	{Object.keys(params.options).map((key) => <option key={key} value={key + ""}>{params.options[key]}</option>)}
</select>

const mapStateToProps = (state: State, props: OwnProps): Params => Object.assign({}, state, props)
const mapDispatchToProps = (dispatch: Dispatch<State>): CallbackParams => ({
	onChange: (a: string) => dispatch({type: "change selection", selected: a})
})

type Action = {type: "change selection", selected: string} | {type: "this isn't expected to be instantiated"}

const reducer: Reducer<State> = (state: State, a?: Action): State => {
	if(!a)
		return state

	switch (a.type) {
		case "change selection":
			return {selected: a.selected}
	}

	return state
}

export const selectOne: CallJs<Params> = (render, props) => {
	const div = document.createElement('div')
	render(div)

	const W = connect(mapStateToProps, mapDispatchToProps)(Select)
	const store = createStore(reducer, {selected: props.selected})

	const modal = ReactDOM.render(<W store={store} name={props.name} options={props.options}/>, div)
}


// WEBPACK FOOTER //
// ./src/searchdirectory/widgets.tsx